import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import apiUrl from "../../environment/Api";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function StaffInfo() {
  const [staff, setStaff] = useState([]); // Initialize as empty array
  const [imageFile, setImageFile] = useState(null);

  const [addData, setAddData] = useState({
    fees: "",
    discount: "",
    payment_type: "",
    duration: "",
  });
  const rowBg = { backgroundColor: "#fceded" };
  const cellText = {
    fontSize: "14px",      // Same as td
    fontWeight: "400",     // Normal (not bold)
  };
  const { id } = useParams();

  useEffect(() => {
    fetchDatas();
  }, [id]);

  const fetchDatas = async () => {
    try {
      const responseStaff = await axios.get(apiUrl + `/staff/${id}`);
      setStaff(responseStaff.data[0]);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  const formatDatefitching = (isoDate) => {
    if (!isoDate) return "";
    const date = new Date(isoDate);
    return date.toISOString().split("T")[0];
  };

  function handleIdProof(e) {
    const file = e.target.files[0];
    if (file) {
      setAddData({ ...addData, id_proof: file });

      const reader = new FileReader();
      reader.onload = () => {
        setImageFile(reader.result); // Display the uploaded image as base64
      };
      reader.readAsDataURL(file);
    }
  }

  const navigate = useNavigate();

  const handlecancel = () => {
    navigate("/staff");
  };

  const handlesubmit = (e) => {
    e.preventDefault();
    console.log("Form data:", addData);
    // Add your logic to handle form submission
  };

  return (
    <>
      <div className="marginup">
        <div className="row">
          <div className="col-lg-11">
            <Link to="/dashboard" className="text-secondary dashBoard_text">
              <b>Dashboard / </b>
            </Link>
            <Link to="/staff" className="text-secondary dashBoard_text">
              <b>Staff Details / </b>
            </Link>
            <Link to="" className="text-danger dashBoard_text">
              <b>Profile</b>
            </Link>
          </div>
        </div>
        <h5>
          <b>Staff Profile</b>
        </h5>
        <div className="row mt-2">
          <div className="col-lg-3 col-sm-3 col-md-3">
            <div className="card carddetails p-2">
              <div className="imgdetails">
                <img
                  src={`${apiUrl}/uploads/${staff.photo_upload}`}
                  alt=""
                  className="img-fluid"
                  style={{ height: "200px", width: "100%", objectFit: "cover" }}
                />
              </div>
              <div className="text-center mt-2 text-white">
                <h6 className="profile-details">
                  <div className="row text-center">
                    <div className="col-lg-1">
                      <i class="fa-solid fa-user "></i>
                    </div>
                    <div className="col-lg-10 text-center">
                      <b> {staff?.name || ""}</b>
                    </div>
                  </div>
                </h6>
                <h6 className="profile-details">
                  <div className="row text-center">
                    <div className="col-lg-1">
                      <i class="fa-solid fa-phone"></i>
                    </div>
                    <div className="col-lg-10 text-center">
                      <b> {staff?.mobile || ""}</b>
                    </div>
                  </div>
                </h6>
                <h6 className="profile-details">
                  <div className="row text-center">
                    <div className="col-lg-1">
                      <i class="fa-solid fa-id-card"></i>
                    </div>
                    <div className="col-lg-10 text-center">
                      <b> {staff?.empid || ""}</b>
                    </div>
                  </div>
                </h6>
                <h6 className="profile-details">
                  <div className="row text-center">
                    <div className="col-lg-1">
                      <i class="fa-solid fa-book"></i>
                    </div>
                    <div className="col-lg-10 text-center">
                      <b> {staff?.designation?.[0]?.department || ""}</b>
                    </div>
                  </div>
                </h6>
                <h6 className="profile-details">
                  <div className="row text-center">
                    <div className="col-lg-1">
                      <i class="fa-solid fa-book"></i>
                    </div>
                    <div className="col-lg-10 text-center">
                      <b> {staff?.designation?.[0]?.designation || ""}</b>
                    </div>
                  </div>
                </h6>
              </div>
            </div>

          </div>

          <div className="col-lg-6">
            <div className="card cardborder p-1">
              <div className="row p-1">
                <div className="col-lg-6 col-md-6 col-sm-6 text-danger">
                  <b>Profile Info</b>
                </div>
              </div>
            </div>

            <div className="card cardborder">
              <div className="p-2">
                <table className="table table-sm mb-0">
                  <tbody>
                    <tr>
                      <th style={{ ...rowBg, ...cellText }}>Branch</th>
                      <td style={{ ...rowBg, ...cellText }}>
                        {staff?.branch_id?.[0]?.branch_name || ""}
                      </td>
                    </tr>

                    <tr>
                      <th style={{...cellText }}>Father Name</th>
                      <td>
                        {staff?.fathername || ""}
                      </td>
                    </tr>

                    <tr>
                      <th style={{ ...rowBg, ...cellText }}>Qualification</th>
                      <td style={{ ...rowBg, ...cellText }}>
                        {staff?.qualification || ""}
                      </td>
                    </tr>

                    <tr>
                      <th style={{...cellText }}>Mobile</th>
                      <td>
                        {staff?.mobile || ""}
                      </td>
                    </tr>

                    <tr>
                      <th style={{ ...rowBg, ...cellText }}>Address</th>
                      <td style={{ ...rowBg, ...cellText }}>
                        {staff?.address || ""}
                      </td>
                    </tr>

                    <tr>
                      <th style={{...cellText }}>Aadhar No.</th>
                      <td>
                        {staff?.aadhar_number || ""}
                      </td>
                    </tr>

                    <tr>
                      <th style={{ ...rowBg, ...cellText }}>Date of Birth</th>
                      <td style={{ ...rowBg, ...cellText }}>
                        {staff?.dateofbirth
                          ? new Date(staff.dateofbirth).toLocaleDateString("en-CA")
                          : ""}
                      </td>
                    </tr>

                    <tr>
                      <th style={{...cellText }}>Email</th>
                      <td>
                        {staff?.email || ""}
                      </td>
                    </tr>

                    <tr>
                      <th style={{ ...rowBg, ...cellText }}>Salary</th>
                      <td style={{ ...rowBg, ...cellText }}>
                        {staff?.salary || ""}
                      </td>
                    </tr>

                    <tr>
                      <th style={{...cellText }}>Notes</th>
                      <td>
                        {staff?.notes || ""}
                      </td>
                    </tr>

                    <tr>
                      <th style={{ ...rowBg, ...cellText }}>Status</th>
                      <td style={{ ...rowBg, ...cellText }}>
                        {staff?.status || ""}
                      </td>
                    </tr>

                    <tr>
                      <th style={{...cellText }}>Timing</th>
                      <td>
                        {staff?.timings || ""}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="col-lg-3">
            <div className="card carddetails p-1">
              <div className="row p-1">
                <div className="col-lg-12 text-danger">
                  <b>Documents</b>
                </div>
              </div>
            </div>
            <div className="card carddetails details-data_overall p-1">
              <div>
                <img
                  src={`${apiUrl}/uploads/${staff.documents}`}
                  alt=""
                  className="img-fluid"
                  style={{ height: "200px", width: "100%", objectFit: "cover" }}
                />
              </div>
            </div>

            <div className="card cardborder p-2">
              <table className="table table-striped table-borderless table-sm mb-0 ">
                <tbody>
                  <tr>
                    <th style={{ width: "45%", fontWeight: 600 }}>User ID</th>
                    <td className="text-end">
                      {staff?.deviceUserId || ""}
                    </td>
                  </tr>

                  <tr>
                    <th>Marital Status</th>
                    <td className="text-end">
                      {staff?.marital_status || ""}
                    </td>
                  </tr>

                  <tr>
                    <th>Gender</th>
                    <td className="text-end">
                      {staff?.gender || ""}
                    </td>
                  </tr>

                  <tr>
                    <th>Join Date</th>
                    <td className="text-end">
                      {staff?.join_date
                        ? new Date(staff.join_date).toLocaleDateString("en-CA")
                        : ""}
                    </td>
                  </tr>

                  <tr>
                    <th>Interview Date</th>
                    <td className="text-end">
                      {staff?.interview_date
                        ? new Date(staff.interview_date).toLocaleDateString("en-CA")
                        : ""}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default StaffInfo;
